<script>
	import { mapActions } from "vuex";
	import { getISODateFromTicks } from "../../utils";

	export default {
		props: {
			domain: {
				type: String,
				required: true
			}
		},
		data() {
			return {
				headers: [
					{
						text: "Aggregators",
						align: "left",
						value: "name"
					},
					{
						text: "Value", value: "result"
					}
				],
				isLoading: false,
				detailAggregators: []
			};
		},
		methods: {
			...mapActions("request", ["fetchAggregators", "fetchAggregatorDetails"]),
			getAggregators(domain) {
				this.isLoading = true;
				this.detailAggregators = [];
				this.fetchAggregators(domain)
					.then(res => this.getAggregatorDetails(res, domain))
					.then(details => this.detailAggregators = details)
					.then(() => this.isLoading = false);
			},
			getAggregatorDetails(aggregators, domain) {
				return Promise.all(
					aggregators.map(aggregator => {
						return this.fetchAggregatorDetails({domain, aggregator})
						.then(aggregatorDetails => {
							this.$emit("pushAggregator", aggregatorDetails);
							return aggregatorDetails;
						})
						.catch(e => console.log(e));
			}))
		}},
		mounted() {
			this.getAggregators(this.domain);
		}
	};
</script>

<template>
	<v-data-table
		:headers="headers"
		:items="detailAggregators"
		:loading="isLoading"
		loading-text="Loading aggregators..."
		no-data-text="No aggregators"
		hide-default-footer
		disable-pagination
	/>
</template>



// WEBPACK FOOTER //
// src/components/elements/AggregatorsTable.vue